export default "__VITE_ASSET__CakqJzgO__"